export default __webpack_public_path__ + "static/media/Facilities-CACS-22.ebcbd27f.jpg";